import joi from 'joi';

const text = {
  fontFamily: joi.string(),
  fontSize: joi.number(),
  fontWeight: joi.string(),
  color: joi.string(),
};

export const validationSchema = joi.object({
  global: joi.object({
    backgroundColor: joi.string(),
    primaryColor: joi.string(),
    secondaryColor: joi.string(),
    blocksColor: joi.string(),
    globalRadius: joi.number(),
    imageRadius: joi.number(),
  }),
  text: joi.object({
    paragraph: joi.object({
      ...text,
      linkColor: joi.string(),
    }),
    title: joi.object({
      ...text,
    }),
    subtitle: joi.object({
      ...text,
    }),
  }),
  button: joi.object({
    ...text,
    backgroundColor: joi.string(),
    borderRadius: joi.number(),
  }),
  progressBar: joi.object({
    backgroundColor: joi.string(),
    progressColor: joi.string(),
  }),
});
